<template>
  <div>
    <div class="tree-data">
      <!-- <el-tree :data="groupTree" :filter-node-method="filterNode" node-key="groupId" ref="treeData" :default-expanded-keys="['0']" draggable :allow-drop="allowDrop">
        <div class="custom-tree-node" slot-scope="{ node, data }">
          <i v-show="data.type!='org'" class="iconfont icon_device"></i>&nbsp;
          <span>{{data.title?data.title:data.uid}}</span>
          <span v-if="data.type=='org'">
            <i class="el-icon-circle-plus" @click="showAddDialog(node,'add')"></i>
            <i class="el-icon-info" @click="showAddDialog(node,'edit')" v-show="data.id!='0'"></i>
            <i class="el-icon-remove" @click="showDeleteDialog(node)" v-show="data.id!='0'" :style="{opacity:node.childNodes.length>0?'0.3':'1'}"></i>
          </span>
        </div>
      </el-tree> -->
      <el-tree :data="groupTree" :props="{ children: 'devices' }" :default-expand-all="true" :expand-on-click-node="false" draggable :allow-drop="allowDrop" :allow-drag="allowDrag" @node-drop="handleNodeDrop">
        <!-- 自定义节点内容 -->
        <template #default="{ node, data }">
          <span>
            <!-- 显示在线状态图标 -->
            <span v-if="'online' in data" style="margin-left: 8px">
              <i v-if="data.online === 1" class="el-icon-success" style="color: #67C23A"></i>
              <i v-else class="el-icon-error" style="color: #F56C6C"></i>
            </span>
            <!-- 显示节点标题 -->
            {{ data.title || data.uid }}
            <!-- 显示备注信息 -->
            <span v-if="data.remark" style="margin-left: 5px; color: #909399">
              ({{ data.remark }})
            </span>
            <span v-if="data.roleTitle" style="margin-left: 5px;">({{ data.roleTitle}})</span>

            <!--操作功能-->
            <template>
              <span v-if="data.type=='all'" style="margin-left: 5px;font-size:16px; color: #409EFF;">
                <i class="el-icon-circle-plus" @click="createGroup"></i>
                <span v-if="isMender" style="color: #fbbd08;margin-left: 50px;font-size:12px;">超级管理员</span>
              </span>
              <template v-if="data.groupId ">
                <!--分组标题-->
                <i style="color: #39b54a;margin-left: 15px;font-size:14px;" class="el-icon-info" @click="editGroupTitle(data)" v-if="data.actions&&data.actions.editGroupTitle && data.actions.editGroupTitle==1 || isMender">标题</i>
                <!--分组备注-->
                <i style="color: #1cbbb4;margin-left: 15px;font-size:14px;" class="el-icon-edit-outline" @click="editGroupRemark(data)" v-if="data.roleId !== 1 &&data.actions && data.actions.editGroupRemark===1 || isMender">备注</i>
                <!--分组转让-->
                <i style="color: #8dc63f;margin-left: 15px;font-size:14px;" class="el-icon-share" @click="transferGroup(data)" v-if="data.actions && data.actions.transferGroup===1 || isMender">转让</i>
                <!--分组成员-->
                <i style="color: #0081ff;margin-left: 15px;font-size:14px;" class="el-icon-user-solid" @click="groupUsers(data)" v-if="data.actions && data.actions.groupUsers===1 || isMender">成员</i>
                <!--退群-->
                <i style="color: #fbbd08;margin-left: 35px;font-size:14px;" class="el-icon-remove" @click="exitGroup(data)" v-if="data.roleId !== 1">退群</i>
                <!--删除-->
                <i style="color: #e54d42;margin-left: 35px;font-size:14px;" class="el-icon-delete-solid" @click="removeGroup(data)" v-if="data.actions && data.actions.removeGroup===1 || isMender">删除</i>
              </template>
            </template>
          </span>

        </template>
      </el-tree>
    </div>
    <Dialog :data="dialog" @sure="modalConfirm">
      <template>
        <div class="c-item">
          <span style="width: 100px;">{{ dialog.inputName }}</span>
          <el-input v-model="dialog.modalInput"></el-input>
        </div>
      </template>
    </Dialog>
    <GroupUser v-if="groupUserShow" @handleClose="groupUserClose" :groupId="groupUserDialog.groupId" :groupTitle="groupUserDialog.title" :roleId="groupUserDialog.roleId"></GroupUser>

  </div>
</template>

<script>
import Dialog from '../../../components/Dialog.vue';
import GroupUser from './groupUser.vue';

export default {
  data() {
    return {
      copyDataArr: [], //用于拖拽失败还原
      //dialog
      dialog: {
        show: false,
        title: '',
        width: '500px',
        modalInput: '',
        inputName: '',
        type: '',
        modelDesc: '',
        groupId: '',
      },
      groupUserDialog: {
        title: '',
        groupId: '',
        roleId: '',
      },

      selectedNode: '', //选中要操作的节点
      operateType: '', //操作类型：add添加，edit编辑，del删除
      loading: false,
      groupTree: [],  //分组设备树数据
      groupDevices: null,
      roleProfile: null,
      isMender: false,
      groupUserShow: false
    }
  },
  components: {
    Dialog,
    GroupUser
  },
  computed: {
    // groupDevices() {
    //   return this.$store.getters['groupsStore/getGroupDevices']
    // },
    // roleProfile() {
    //   return this.$store.getters['groupsStore/getRoleProfile']
    // }
  },
  watch: {
    '$store.state.groupsStore.groupDevices': {
      handler() {
        this.groupDevices = this.$store.state.groupsStore.groupDevices;
        this.checkAndLoadTree();
      }
    },
    '$store.state.groupsStore.roleProfile': {
      handler() {
        this.roleProfile = this.$store.state.groupsStore.roleProfile;
        this.checkAndLoadTree();
      },

    },
    '$store.state.settingStore.isMender': {
      handler() {
        this.isMender = this.$store.state.settingStore.isMender;
      }
    },
    // groupDevices(newVal) {
    //   this.checkAndLoadTree();
    // },
    // roleProfile(newVal) {
    //   this.checkAndLoadTree();
    // }
  },
  methods: {
    checkAndLoadTree() {
      if (this.groupDevices !== null && this.roleProfile !== null) {
        this.setGroupTree();
      }
    },
    //设置分组数据
    setGroupTree() {
      // let groupDevices = this.$store.getters['groupsStore/getGroupDevices']
      // let roleProfile = this.$store.getters['groupsStore/getRoleProfile']
      console.log(4444, this.groupDevices);
      console.log(4445, this.roleProfile);
      this.groupDevices.forEach(item => {
        //处理分组名称部分
        const roleProfile = this.findRoleById(item.roleId)
        if (roleProfile) {
          item.roleTitle = roleProfile.title || ""	//增加群权限名称
          item.actions = roleProfile.actions || {}	//增加群权限
        }
        if (item.devices) {
          //取出数组
          item.devices.forEach(deviceItem => {
            deviceItem.actions = this.filterDeviceActions(item.roleId)
            deviceItem.deviceGroupId = item.groupId	//增加分组id
          })
        }
      });
      let groupDevices = this.groupDevices
      this.groupTree = [
        {
          title: "全部设备", // 这个label是顶级节点显示用的
          devices: groupDevices,
          type: 'all',
        }
      ]
      console.log(3333, this.groupTree);

    },
    //查找分组的权限
    findRoleById(roleId) {
      const roleProfile = this.roleProfile
      // const defActions = ['editGroupTitle','editGroupRemark',
      // 'groupUsers','addGroupUser','moveGroupDevice','removeGroup','removeGroupUser','transferGroup']
      return roleProfile.find(item => item.id === roleId);
    },
    //筛选设备的权限
    filterDeviceActions(roleId) {
      const defActions = ['moveGroupDevice']

      // 根据roleId查找对应的角色
      const targetRole = this.findRoleById(roleId)

      // 如果没有找到角色或没有actions则返回空对象
      if (!targetRole || !targetRole.actions) return {};

      // 过滤defActions中存在的权限
      return defActions.reduce((acc, action) => {
        if (targetRole.actions[action] !== undefined) {
          acc[action] = targetRole.actions[action];
        }
        return acc;
      }, {});
    },
    //编辑分组名称
    createGroup(data) {
      this.dialog.show = true
      this.dialog.title = '新增分组'
      this.dialog.type = 'createGroup'
      this.dialog.modalInput = ''
      this.dialog.inputName = '分组名称'
      this.dialog.groupId = ''
    },
    //编辑分组名称
    editGroupTitle(data) {
      this.dialog.show = true
      this.dialog.title = '修改[' + data.title + ']名称'
      this.dialog.type = 'editGroupTitle'
      this.dialog.modalInput = data.title
      this.dialog.inputName = '分组名称'
      this.dialog.groupId = data.groupId
    },
    editGroupRemark(data) {
      this.dialog.show = true
      let title = data.remark || data.title
      this.dialog.title = '修改[' + title + ']备注'
      this.dialog.type = 'editGroupRemark'
      this.dialog.modalInput = data.remark
      this.dialog.inputName = '备注名称'
      this.dialog.groupId = data.groupId
    },
    transferGroup(data) {
      this.dialog.show = true
      this.dialog.title = '转让[' + data.title + ']分组群主'
      this.dialog.type = 'transferGroup'
      this.dialog.modalInput = ''
      this.dialog.inputName = '小程序ID'
      this.dialog.groupId = data.groupId
    },

    //确认
    modalConfirm() {
      if (this.dialog.type == 'createGroup') {
        this.saveCreateGroup()
      }
      if (this.dialog.type == 'editGroupTitle') {
        this.saveEditGroupTitle()
      }
      if (this.dialog.type == 'editGroupRemark') {
        this.saveEditGroupRemark()
      }
      if (this.dialog.type == 'transferGroup') {
        this.saveTransferGroup()
      }
    },
    //新建分组
    saveCreateGroup() {
      const modalInput = this.dialog.modalInput
      if (modalInput == "") {
        this.common.cToast(this, '请输入名称')
        return
      }
      let json = {
        "cmd": "createGroup",
        "title": modalInput
      }
      this.ws.send(json);
    },
    //保存修改群组名称
    saveEditGroupTitle() {
      const modalInput = this.dialog.modalInput
      if (modalInput == "") {
        this.common.cToast(this, '请输入名称')
        // this.common.showMessage('请输入名称')
        return
      }
      let json = {
        "cmd": "editGroupTitle",
        "groupId": this.dialog.groupId,
        "title": modalInput
      }
      this.ws.send(json);
    },
    //保存修改群组名称
    saveEditGroupRemark() {
      const modalInput = this.dialog.modalInput
      if (modalInput == "") {
        this.common.cToast(this, '请输入分组备注')
        return
      }
      let json = {
        "cmd": "editGroupRemark",
        "groupId": this.dialog.groupId,
        "title": modalInput
      }
      this.ws.send(json);
    },
    //保存修改群组名称
    saveTransferGroup() {
      const modalInput = this.dialog.modalInput
      if (modalInput == "") {
        this.common.cToast(this, '请输入小程序ID')
        return
      }
      let json = {
        "cmd": "transferGroup",
        "groupId": this.dialog.groupId,
        "wechatToken": modalInput
      }
      this.ws.send(json);
    },
    //退出分组
    exitGroup(data) {
      this.$confirm('确认退出[' + data.title + ']分组?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let json = {
          "cmd": "exitGroup",
          "groupId": data.groupId,
        };
        this.ws.send(json);

      }).catch(() => {

      });
    },
    //删除分组
    removeGroup(data) {
      if (data.devices && data.devices.length) {
        this.common.cToast(this, '请先删除分组内设备')
        return
      }
      this.$confirm('确认删除[' + data.title + ']分组?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let json = {
          "cmd": "removeGroup",
          "groupId": data.groupId,
        };
        this.ws.send(json);

      }).catch(() => {

      });
    },
    updateGroup() {
      this.ws.send({
        "cmd": "groups"
      })
    },
    groupUsers(data) {
      this.groupUserDialog.title = data.title;
      this.groupUserDialog.groupId = data.groupId;
      this.groupUserDialog.roleId = data.roleId;
      console.log(666, data);

      this.groupUserShow = true
    },
    groupUserClose(res) {
      this.groupUserDialog.title = null
      this.groupUserDialog.groupId = null
      this.groupUserDialog.roleId = null;

      this.groupUserShow = false
    },
    // 拖拽相关方法
    allowDrag(node) {
      // 只有设备节点可以被拖拽
      return 'online' in node.data;
    },
    allowDrop(draggingNode, dropNode, type) {
      const dragData = draggingNode.data;
      const dropData = dropNode.data;

      // 只能将设备拖拽到分组内
      if (type !== 'inner') return false;

      // 只有设备可以被拖拽
      if (!('online' in dragData)) return false;

      // 只能拖拽到分组节点（不能是设备节点或根节点）
      if (!dropData.groupId) return false;

      // 检查目标分组是否有移动设备的权限
      if (dropData.actions && dropData.actions.moveGroupDevice === 1) {
        return true;
      }

      // 超级管理员可以无视权限限制
      // if (this.isMender) return true;
      return false;
    },
    handleNodeDrop(draggingNode, dropNode, dropType, ev) {
      const dragData = draggingNode.data;
      const dropData = dropNode.data;
      // console.log(111, dragData.deviceGroupId);
      // console.log(222, dropData.groupId);
      // console.log(333, dragData.uid);

      // 检查目标分组是否有移动设备的权限
      // if (!(dropData.actions && dropData.actions.moveGroupDevice === 1)) {
      //   // 如果没有权限，显示提示信息
      //   this.common.cToast(this, '目标分组无移动设备权限');
      //   return;
      // }
      // 发送移动设备的请求
      let json = {
        "cmd": "moveGroupDevice",
        "uid": dragData.uid,
        "newGroupId": dropData.groupId,
        "groupId": dragData.deviceGroupId
      };
      this.ws.send(json);
    }
  },
  mounted() {
    this.checkAndLoadTree();
    // 操作成功/失败
    const operateResult = (type, dialog, msg) => {
      this.loading = false;
      if (type == "ok") {
        this.common.cResultOk(this);
      } else {
        this.common.cResultNo(this, msg);
      }
      dialog.show = false;
    }

    this.ws.addCallback("createGroupAck", (res) => {
      if (this.common.cGetResult(res)) {
        operateResult('ok', this.dialog);
        this.updateGroup()
      } else {
        let errorMsg = this.common.checkGroupErrorDesc(res.error);
        operateResult('no', this.dialog, errorMsg);
      }
    })

    this.ws.addCallback("editGroupTitleAck", (res) => {
      if (this.common.cGetResult(res)) {
        operateResult('ok', this.dialog);
        this.updateGroup()
      } else {
        let errorMsg = this.common.checkGroupErrorDesc(res.error);
        operateResult('no', this.dialog, errorMsg);
      }
    })

    this.ws.addCallback("editGroupRemarkAck", (res) => {
      if (this.common.cGetResult(res)) {
        operateResult('ok', this.dialog);
        this.updateGroup()
      } else {
        let errorMsg = this.common.checkGroupErrorDesc(res.error);
        operateResult('no', this.dialog, errorMsg);
      }
    })

    this.ws.addCallback("transferGroupAck", (res) => {
      if (this.common.cGetResult(res)) {
        operateResult('ok', this.dialog);
        this.updateGroup()
      } else {
        let errorMsg = this.common.checkGroupErrorDesc(res.error);
        operateResult('no', this.dialog, errorMsg);
      }
    })
    this.ws.addCallback("exitGroupAck", (res) => {
      if (this.common.cGetResult(res)) {
        operateResult('ok', this.dialog);
        this.updateGroup()
      } else {
        let errorMsg = this.common.checkGroupErrorDesc(res.error);
        operateResult('no', this.dialog, errorMsg);
      }
    })
    this.ws.addCallback("removeGroupAck", (res) => {
      if (this.common.cGetResult(res)) {
        operateResult('ok', this.dialog);
        this.updateGroup()
      } else {
        let errorMsg = this.common.checkGroupErrorDesc(res.error);
        operateResult('no', this.dialog, errorMsg);
      }
    })
    this.ws.addCallback("moveGroupDeviceAck", (res) => {
      if (this.common.cGetResult(res)) {
        operateResult('ok', this.dialog);
        this.updateGroup()
      } else {
        let errorMsg = this.common.checkGroupErrorDesc(res.error);
        operateResult('no', this.dialog, errorMsg);
      }
    })
  },


}
</script>

<style lang="scss">
.tree-data {
  flex: auto;
  overflow: auto;
}

.el-button {
  height: 40px;
}
</style>